import { ShoppingBag } from "lucide-react";
import { useQuote } from "@/context/QuoteContext";
import { useLocation } from "react-router-dom";

/**
 * Floating cart pill — pinned bottom-right on every collection/landing page.
 * The count badge floats detached above the pill's top-right corner
 * (Amazon-style) so it always reads as a live counter over the button.
 * Pill width is locked so the button never flashes, jumps, or resizes.
 */
export default function FloatingCartButton() {
  const { totalQuantity, openCartDrawer } = useQuote();
  const { pathname } = useLocation();
  // The full configurator already has inline cart/review controls in this corner.
  if (totalQuantity === 0 || pathname === "/configurator" || pathname.startsWith("/admin")) return null;
  const display = totalQuantity > 99 ? "99+" : String(totalQuantity);
  return (
    <button
      onClick={openCartDrawer}
      className="fixed bottom-24 right-6 md:bottom-28 md:right-8 z-40 inline-flex items-center gap-2.5 pl-4 pr-5 h-12 bg-brand-green text-brand-bone shadow-xl hover:bg-brand-green/90 border border-brand-gold/40 select-none will-change-transform"
      style={{ minWidth: "120px" }}
      data-testid="floating-cart-button"
      aria-label={`Open cart · ${totalQuantity} doors`}
    >
      <ShoppingBag size={18} className="text-brand-gold shrink-0" />
      <span className="text-[0.72rem] tracking-[0.28em] uppercase flex-1 text-left">
        Cart
      </span>
      <span
        className="absolute -top-2.5 -right-2.5 inline-flex items-center justify-center min-w-[26px] h-[26px] px-1.5 rounded-full bg-brand-gold text-brand-green text-[0.78rem] font-semibold tabular-nums shadow-md ring-2 ring-brand-bone"
        data-testid="floating-cart-count"
      >
        {display}
      </span>
    </button>
  );
}
